import { render, staticRenderFns } from "./VASlideItem.vue?vue&type=template&id=a2bd35b2&scoped=true&"
import script from "./VASlideItem.vue?vue&type=script&lang=js&"
export * from "./VASlideItem.vue?vue&type=script&lang=js&"
import style0 from "./VASlideItem.vue?vue&type=style&index=0&id=a2bd35b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bd35b2",
  null
  
)

export default component.exports